import type { IDeviceTypeCount } from '../../types/device-type-count';
import type { IHeatmapAnalyticStore } from '../../stores';
import type { EDeviceType } from '../../types/device';
import type { IHeatmapAnalytics } from '../../types';

import { createViewContextHook } from '@gem-sdk/heatmap-react';
import { useHeatmapAnalyticStore } from '../../stores';

interface IHeatmapAnalyticState {
  data: IHeatmapAnalytics | undefined;
  getByDeviceType: (deviceType: EDeviceType) => IDeviceTypeCount | undefined;
}

interface IHeatmapAnalyticActions {
  setData: (data: IHeatmapAnalytics) => void;
  clearView: (viewId: string) => void;
}

export const useHeatmapAnalyticContext = createViewContextHook<
  IHeatmapAnalyticStore,
  IHeatmapAnalyticState,
  IHeatmapAnalyticActions
>({
  useStore: useHeatmapAnalyticStore,

  getState: (store, viewId) => {
    const data = store.data.get(viewId);

    return {
      data,
      getByDeviceType: (deviceType) =>
        data?.deviceTypeDistribution.find((d) => d.deviceType === deviceType),
    };
  },

  getActions: (store, viewId) => ({
    setData: (data) => store.setData(data, viewId),
    clearView: (viewId) => store.clearView(viewId),
  }),
});
